import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ClientManagementPanel = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center shrink-0">
            <Icon name="Briefcase" size={24} color="var(--color-primary)" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-2">Client Management Database</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Access the comprehensive client management system to view, create, edit, and manage all client information and relationships.
            </p>
            <Button
              onClick={() => navigate('/client-management-database')}
              className="flex items-center gap-2"
            >
              <Icon name="ExternalLink" size={18} />
              Open Client Management
            </Button>
          </div>
        </div>
      </div>

      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Quick Overview</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Users" size={20} color="var(--color-primary)" />
              <span className="text-sm font-medium text-muted-foreground">Total Clients</span>
            </div>
            <p className="text-2xl font-bold text-foreground">-</p>
          </div>
          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="CheckCircle" size={20} color="var(--color-green-500)" />
              <span className="text-sm font-medium text-muted-foreground">Active Clients</span>
            </div>
            <p className="text-2xl font-bold text-foreground">-</p>
          </div>
          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="FolderOpen" size={20} color="var(--color-primary)" />
              <span className="text-sm font-medium text-muted-foreground">Projects Linked</span>
            </div>
            <p className="text-2xl font-bold text-foreground">-</p>
          </div>
        </div>
      </div>

      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Features</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex items-start gap-3">
            <Icon name="Search" size={20} color="var(--color-primary)" className="mt-1" />
            <div>
              <h4 className="text-sm font-semibold text-foreground mb-1">Advanced Search & Filtering</h4>
              <p className="text-xs text-muted-foreground">Search clients by name, contact, or email with industry and status filters</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Icon name="Edit" size={20} color="var(--color-primary)" className="mt-1" />
            <div>
              <h4 className="text-sm font-semibold text-foreground mb-1">Full CRUD Operations</h4>
              <p className="text-xs text-muted-foreground">Create, read, update, and delete client records with comprehensive forms</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Icon name="Link" size={20} color="var(--color-primary)" className="mt-1" />
            <div>
              <h4 className="text-sm font-semibold text-foreground mb-1">Project Integration</h4>
              <p className="text-xs text-muted-foreground">Link clients to projects during creation and track relationships</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Icon name="FileText" size={20} color="var(--color-primary)" className="mt-1" />
            <div>
              <h4 className="text-sm font-semibold text-foreground mb-1">Detailed Information</h4>
              <p className="text-xs text-muted-foreground">Store company details, contacts, addresses, and custom notes</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientManagementPanel;